var _style, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTap = function SvgIconTap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391 211c-5.9 0-11.4 1.1-16.6 3.2C369.2 195.1 351.7 181 331 181c-11.5 0-22 4.3-30 11.5 -8-7.1-18.5-11.5-30-11.5 -5.3 0-10.3 0.9-15 2.6V135c0-24.8-20.2-45-45-45s-45 20.2-45 45v132.4c-7.2-7.2-13.2-13.2-13.2-13.2 -16.6-16.6-43.6-17.6-61.3-2.2 -17.8 15.4-20.7 42.2-6.5 61 0.2 0.2 0.3 0.4 0.5 0.6l66.7 79.7c7.2 8.7 17.7 14 26.9 18.7 6.7 3.4 16.9 8.6 16.9 11.9V467c0 24.8 20.2 45 45 45h120c24.8 0 45-20.2 45-45v-31c0-5.9 5.7-13.1 11.7-20.7 8.6-10.7 18.3-22.9 18.3-39.3V256C436 231.2 415.8 211 391 211zM394.2 396.7c-8.6 10.7-18.3 22.9-18.3 39.3v31c0 8.3-6.7 15-15 15h-120c-8.3 0-15-6.7-15-15v-43c0-21.6-19.2-31.5-33.2-38.6 -7-3.6-14.3-7.3-17.6-11.3l-66.4-79.3c-4.5-6.3-3.5-15 2.4-20.1 5.9-5.1 14.9-4.8 20.4 0.7 0 0 36.3 36.3 38.8 38.8 9.4 9.4 25.6 2.7 25.6-10.6V135c0-8.3 6.7-15 15-15s15 6.7 15 15v121c0 8.3 6.7 15 15 15s15-6.7 15-15v-30c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v30c0 8.3 6.7 15 15 15s15-6.7 15-15v-30c0-8.3 6.7-15 15-15s15 6.7 15 15v30c0 8.3 6.7 15 15 15s15-6.7 15-15c0-8.3 6.7-15 15-15s15 6.7 15 15v120h0C406 381.9 400.3 389.1 394.2 396.7z",
    "data-original": "#000000",
    className: "a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211 0c-8.3 0-15 6.7-15 15v30c0 8.3 6.7 15 15 15s15-6.7 15-15V15C226 6.7 219.3 0 211 0z",
    "data-original": "#000000",
    className: "a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.2 23.8c-5.9-5.9-15.4-5.9-21.2 0L249.8 45c-5.9 5.9-5.9 15.4 0 21.2 5.9 5.9 15.4 5.9 21.2 0L292.2 45C298.1 39.1 298.1 29.6 292.2 23.8z",
    "data-original": "#000000",
    className: "a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2 45l-21.2-21.2c-5.9-5.9-15.4-5.9-21.2 0 -5.9 5.9-5.9 15.4 0 21.2l21.2 21.2c5.9 5.9 15.4 5.9 21.2 0C178.1 60.4 178.1 50.9 172.2 45z",
    "data-original": "#000000",
    className: "a"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316 90h-30c-8.3 0-15 6.7-15 15s6.7 15 15 15h30c8.3 0 15-6.7 15-15S324.3 90 316 90z",
    "data-original": "#000000",
    className: "a"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 90h-30c-8.3 0-15 6.7-15 15s6.7 15 15 15h30c8.3 0 15-6.7 15-15S144.3 90 136 90z",
    "data-original": "#000000",
    className: "a"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-tap.a2cc7396.svg";
export { ForwardRef as ReactComponent };